import React, { ReactElement, ReactNode, ReactNodeArray } from "react";
import { Property } from "csstype";

type SimpleTableProps = {
  content: (React.ReactNode[] | React.ReactNode)[];
  header?: React.ReactNode;
  width?: string[] | number[];
  separating_borders?: number[];
  textAlign?: Property.TextAlign[];
} & Omit<React.HTMLAttributes<HTMLDivElement>, "content">;

const SimpleTable: React.FC<SimpleTableProps> = ({
  className,
  header,
  content,
  width,
  textAlign,
  separating_borders,
}: SimpleTableProps) => {
  return (
    <table className={`simple-table ${className || ""} `}>
      {header && (
        <thead>
          <tr>
            <td>{header}</td>
          </tr>
        </thead>
      )}
      <tbody>
        {content.map((row: any, i: number) => (
          <tr key={i}>
            {row.map((td: any[], j: number, arr: any[]) => (
              <td
                key={j}
                colSpan={arr.length === 2 ? 1 : 2}
                width={width ? width[j] : ""}
                className={
                  separating_borders && separating_borders.includes(i)
                    ? "border-bottom"
                    : ""
                }
                style={{ textAlign: textAlign ? textAlign[j] : "left" }}
              >
                {td}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SimpleTable;
